import React, { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const FAQ = ({ blok }) => {
  const [showAnswer, setShowAnswer] = useState(false);

  const handleQuestionClick = () => {
    setShowAnswer(!showAnswer);
  };

  return (
    <div className="faq-content" {...storyblokEditable(blok)}>
      <div className="faq-question flex items-center" onClick={handleQuestionClick}>
        <span>{blok.question1}</span>
        <img
          src="/src/arrow.png"
          alt=""
          style={{
            transform: `rotate(${showAnswer ? 180 : 0}deg)`,
            transition: "transform 0.2s",
          }}
        />
      </div>
      {showAnswer && (
        <div className="faq-answer flex">
          <p>
            {blok.answer1}
            {blok.link && <Link href={blok.link} > {blok.linktext}</Link>}
            {blok.linknewtab && (
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={blok.linknewtab}
                >
                  {" "}
                  {blok.linktextnewtab}
              </Link>
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default FAQ;
